export { default } from './TitleLeafImageTextRow';
export type {
  IPrismicTitleLeafImageTextRowItem,
  IPrismicTitleLeafImageTextRowPrimary,
} from './types';
